// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { DocumentType } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "../../../types";
import type { IGetDocumentTypesparams, IPutDocumentTypesParams, IPostDocumentTypesParams } from "./DocumentTypes";
import {
	createGetMethod,
	createPostMethod,
	createGetByUidMethod,
	createPutMethod,
} from "./helpers/documentTypesMethodsHelpers";

interface DocumentTypesInstance {
	get(q: IGetDocumentTypesparams): Promise<DocumentType[]>;
	post(body: IPostDocumentTypesParams): Promise<DocumentType>;
	getByUid(uid: string, q?: QueryPayload): Promise<DocumentType>;
	put(uid: string, body: IPutDocumentTypesParams): Promise<DocumentType>;
}

// Module-level singleton instance
let instance: DocumentTypesInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createDocumentTypes(): DocumentTypesInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;
	const baseUrl = baseNotary.namespaceUrl.concat("/document-types");

	return {
		get: createGetMethod(baseNotary, baseUrl),
		post: createPostMethod(baseNotary, baseUrl),
		getByUid: createGetByUidMethod(baseNotary, baseUrl),
		put: createPutMethod(baseNotary, baseUrl),
	};
}

export function getDocumentTypesInstance(): DocumentTypesInstance {
	if (!instance) {
		instance = createDocumentTypes();
	}
	return instance;
}
